export default __webpack_public_path__ + "static/media/hero-image-night.579a3cd9.png";